import type { CustomCell, CustomRenderer } from '@glideapps/glide-data-grid'
import { getMiddleCenterBias, GridCellKind } from '@glideapps/glide-data-grid'
import { formatMoney } from '@utils/money'

interface MoneyCellProps {
  readonly kind: 'money-cell'
  readonly currency: string
  readonly value: number | null
}

export type MoneyCell = CustomCell<MoneyCellProps>

export const moneyCellRenderer = (locale: string): CustomRenderer<MoneyCell> => ({
  draw: (args, cell) => {
    const { ctx, theme, rect } = args
    const { currency, value } = cell.data

    if (value === null || value === undefined || !currency) {
      return true
    }

    const formatted = formatMoney(locale, { amount: value, currency })

    ctx.font = `${theme.baseFontStyle} ${theme.fontFamily}`
    ctx.fillStyle = theme.textDark
    ctx.textAlign = 'right'
    ctx.fillText(
      formatted,
      rect.x + rect.width - theme.cellHorizontalPadding,
      rect.y + rect.height / 2 + getMiddleCenterBias(ctx, theme),
    )

    return true
  },
  isMatch: (c): c is MoneyCell => (c.data as MoneyCellProps).kind === 'money-cell',
  kind: GridCellKind.Custom,
})
